import { Cost } from './Cost';
import { EsgMarket } from './EsgMarket';
import { FundDocument } from './FundDocument';
import { FlamingoFundType, FundType } from './FundType';
import { Identified } from './Identified';
import { Quotes } from './Quotes';
import { Risk } from './Risk';
import { TargetMarket } from './TargetMarket';
import { Umbrella } from './Umbrella';
import { ValueWithSeq } from './ValueWithSeq';

import Decimal from 'decimal.js';

export enum SfdrCategoryId {
  NO_ESG = 1,
  ART_8 = 2,
  ART_9 = 3,
}

export interface Fund extends FlamingoFund {
  readonly name: string;
  readonly fundType: FundType;
  readonly quotesForUnitCode: Record<string, Quotes>;
  readonly afsCodeForUnitCode: Record<string, string>;
  readonly horizonValue: number;
  readonly risk: Risk;
  readonly riskProfilerLevelValue?: number;
  readonly shortText1: string;
  readonly url: string;
  readonly identifier: string;
  readonly umbrella?: Umbrella;
  readonly analizyOnlineRating?: number
  readonly goalsAndInvestmentPolicies: ValueWithSeq[];
  readonly documentsForUnitCode: Record<string, FundDocument[]>;
  readonly costsForUnitCode: Record<string, Cost>;
  readonly esgMarket?: EsgMarket;
  readonly sfdrCategoryId?: SfdrCategoryId;
  readonly targetMarkets: TargetMarket[];
  readonly previousName?: string;
}


export interface AdditionalTab {
  readonly name: string;
  readonly content: string;
}

export interface FundAttributeValue {
  unitCategoryCode?: string;
  value?: string;
}

export interface FundAttribute {
  key: string;
  values: FundAttributeValue[];
  seq: number;
}

export interface FundManagerPhotoData extends Identified {
  nameAndSurname: string;
  photoAlt: string;
  photoBase64: string;
  position: string;
  photoContentType: string;
}

export interface FundManager {
  readonly peopleId: number;
  readonly seq: number;
}
export interface ModelWalletStructure {
  readonly unitCategory: string;
  readonly modelWalletAllocation: string;
  readonly share: number;
  readonly seq: number;
}

export interface FundVisibility {
  readonly isVisibleInAUnit: boolean;
  readonly isVisibleInKUnit: boolean;
  readonly isVisibleInEUnit: boolean;
  readonly isVisibleInFUnit: boolean;
  readonly isVisibleInIUnit: boolean;
  readonly isVisibleInPUnit: boolean;
  readonly isVisibleInSUnit: boolean;
  readonly isVisibleInTUnit: boolean;
  readonly isVisibleInWUnit: boolean;
}


export interface FlamingoFund extends Identified {
  readonly name: string;
  readonly idForPhoto?: number;
  readonly additionalTab?: AdditionalTab;
  readonly fundPhoto?: string;
  readonly fundPhotoType?: string;
  readonly isApiFundPhotoChecked?: boolean;
  readonly fundManagersPhoto?: FundManagerPhotoData[];
  readonly fundManagers: FundManager[];
  readonly modelWalletStructure: ModelWalletStructure[];
  readonly fundType: FlamingoFundType;
  readonly quotesForUnitCode: Record<string, Quotes>;
  readonly oldestQuotesForUnitCode: Record<string, Quotes>;
  readonly afsCodeForUnitCode: Record<string, string>;
  readonly horizonValue: number;
  readonly risk: Risk;
  readonly riskProfilerLevelValue?: number;
  readonly shortText1: string;
  readonly url: string;
  readonly identifier: string;
  readonly umbrella?: Umbrella;
  readonly analizyOnlineRating?: number
  readonly goalsAndInvestmentPolicies: ValueWithSeq[];
  readonly forWhom: ValueWithSeq[];
  readonly documentsForUnitCode: Record<string, FundDocument[]>;
  readonly costsForUnitCode: Record<string, Cost>;
  readonly esgMarket?: EsgMarket;
  readonly sfdrCategoryId?: SfdrCategoryId;
  readonly fundVisibility: FundVisibility;
  readonly targetMarkets: TargetMarket[];
  readonly previousName?: string;
  readonly attributes?: FundAttribute[];
}

export interface PurchasableFund extends FlamingoFund {
  readonly amountOwned?: Decimal;
  readonly selected?: boolean;
  readonly minPurchase?: number;
  readonly minPurchaseOpening?: number;
  readonly minRedemption?: number;
  readonly minExchangeIn?: number;
  readonly minExchangeInOpening?: number;
  readonly minExchangeOut?: number;
}
